<template>
    <div class="item-question-rating">
        <div class="d-flex flex-row">
            <label v-if="numberContent != ''" class="text-color-number mb-1">
                {{ numberContent }}
            </label>
            <label class="text-color-questions mb-1 ps-2"
                   v-html="labelContent">
            </label>
        </div>
        <div
            v-if="question.additionalInfo"
            class="form-input-help mb-1"
            v-html="question.additionalInfo"
        >
        </div>
        <rating-input
            :class-rating="divQuestionChildClass"
            :error-text="translate('label.this_value_is_required')"
            :field-id="question.questionId"
            :name="fieldName"
            :options="options"
            :question="question"
            :type="'rating'"
            :validation="validationRules"
            :has-submitted="hasSubmitted"
            @update:modelAnswer="changeValue($event, question)"
            @register-field="handleFieldRegister"
            @field-change="handleFieldChange"
        />
    </div>
</template>
<script setup>
import { computed, onMounted } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import RatingInput from "../components/rating-input.vue";
import { useTranslation } from '@/composables/useTranslation';

// INITIALIZE STORES AND COMPOSABLES
const playerStore = usePlayerStore();
const { translate } = useTranslation();

// PROPS AND EMITS
const props = defineProps({
    enumeration: {
        type: Number,
        required: false,
        default: 0,
    },
    question: {
        type: Object,
        required: true,
    },
    showNumbering: {
        type: Boolean,
        required: false,
        default: false,
    },
    translateLabels: {
        type: Object,
        required: true,
    },
    TYPE_FIELD_ID: {
        type: Number,
        required: true,
    },
    hasSubmitted: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['field-change', 'register-field']);

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const fieldName = computed(() =>
    `question_${props.TYPE_FIELD_ID}_${props.question.questionId}_${props.question.fieldType}`
);

const divQuestionChildClass = computed(() => {
    let classes = props.question.shapesCssName;
    return classes;
});

const labelContent = computed(() => {
    const label = [];

    if (Boolean(props.question.required)) {
        label.push(`* ${props.question.description}`);
    } else {
        label.push(props.question.description);
    }

    return label.join(' ');
});

const numberContent = computed(() => {
    const label = [];

    if (Boolean(props.showNumbering)) {
        label.push(`${String(props.enumeration).padStart(2, '0')}.`);
    }

    return label.join(' ');
});

const options = computed(() => {
    const options = [];
    for (let i = props.question.stepsRating; i >= 1; i--) {
        options.push({
            value: i,
            label: '',
            id: `rating-${props.question.questionId}-${i}`
        });
    }
    return options;
});

const validationRules = computed(() => {
    const rules = {
        required: false,
    };
    if (props.question.required) {
        rules.required = true;
    }

    return rules;
});

// METHODS
const changeValue = (newValue, qt) => {
    qt.answer = newValue;
    emit('field-change', fieldName.value, newValue);
    playerStore.setAnswerInFormQuestions(qt);
};

const handleFieldRegister = (fieldName, initialValue) => {
    emit('register-field', fieldName, initialValue);
};

const handleFieldChange = (fieldName, value) => {
    emit('field-change', fieldName, value);
};

// LYFECYCLE HOOKS
onMounted(async () => {
    const initialValue = props.question.answer || '';
    emit('register-field', fieldName.value, initialValue);
});
</script>
